import { useCallback, useEffect, useState } from 'react'
import { useInterval } from 'usehooks-ts'

import { calculateRemainingTime, formatTime } from './utils'

type FormattedRemainingTime = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const MS_PER_SECOND = 1000

const parseDateToSeconds = (date: string) => Math.floor(Date.parse(date) / MS_PER_SECOND)

const useCountdown = (endDate: string) => {
  const endTimeInSeconds = parseDateToSeconds(endDate)
  const [formattedRemainingTime, setFormattedRemainingTime] = useState<FormattedRemainingTime>()
  const [isCountdownActive, setIsCountdownActive] = useState(!!endTimeInSeconds)

  const updateRemainingTime = useCallback(() => {
    if (!endTimeInSeconds) return

    const timeLeft = calculateRemainingTime(endTimeInSeconds)

    setIsCountdownActive(timeLeft > 0)
    setFormattedRemainingTime(formatTime(timeLeft))
  }, [endTimeInSeconds])

  useEffect(updateRemainingTime, [updateRemainingTime])
  useInterval(updateRemainingTime, isCountdownActive ? MS_PER_SECOND : null)

  return { formattedRemainingTime, isCountdownActive }
}

export default useCountdown
